export default {
  authErrorPrefix: 'Erro ao autenticar: ',
  authenticating: 'Autenticando...',
};
